import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Project detail route. Redirects to the projects list page.
 * The project drawer is managed via state on the projects list page,
 * so deep-linking to a specific project just goes to the list.
 */
export const Route = createFileRoute("/_authenticated/projects/$projectId")({
  beforeLoad: () => {
    throw redirect({ to: "/projects" });
  },
});
